import { useState } from "react";
import { Search, MapPin, Filter, ChevronDown } from "lucide-react";

const SearchBar = ({ onSubmit }) => {
  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");
  const [filterOpen, setFilterOpen] = useState(false);
  const [sortOption, setSortOption] = useState("newest");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ keyword, location, sortOption });
    // Here you would typically handle the search submission
  };

  const handleSortChange = (option) => {
    setSortOption(option);
    setFilterOpen(false);
  };

  const sortOptions = [
    { value: "newest", label: "Newest First" },
    { value: "oldest", label: "Oldest First" },
    { value: "titleAsc", label: "By Title (A-Z)" },
    { value: "titleDesc", label: "By Title (Z-A)" },
  ];

  return (
    <div className="w-full max-w-5xl mx-auto">
      <div className="w-full">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Keyword search */}
          <div className="flex-1 relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="Search keywords..."
              className="pl-10 pr-3 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            />
          </div>

          {/* Location search */}
          <div className="flex-1 relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <MapPin className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="Location..."
              className="pl-10 pr-3 py-2 w-full rounded-lg border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
            />
          </div>

          {/* Filter dropdown */}
          <div className="relative">
            <button
              type="button"
              onClick={() => setFilterOpen(!filterOpen)}
              className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
            >
              <Filter className="h-5 w-5 text-gray-500" />
              <span className="text-gray-700">
                {
                  sortOptions.find((option) => option.value === sortOption)
                    ?.label
                }
              </span>
              <ChevronDown className="h-4 w-4 text-gray-500" />
            </button>

            {filterOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                <ul className="py-1">
                  {sortOptions.map((option) => (
                    <li key={option.value}>
                      <button
                        type="button"
                        onClick={() => handleSortChange(option.value)}
                        className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${sortOption === option.value
                            ? "bg-blue-50 text-blue-600"
                            : "text-gray-700"
                          }`}
                      >
                        {option.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Submit button */}
          <button
            onClick={handleSubmit}
            className="bg-indigo-500 hover:bg-indigo-700 text-white font-medium py-2 px-6 rounded-lg transition-colors"
          >
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
